import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    UrlTree,
} from '@angular/router';
import { LearnModuleType } from '@cna/projects/ak-jura/shared/interfaces';
import { filterNil } from '@cna/shared/helper';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { filter, map, switchMap } from 'rxjs/operators';
import { loadCourseParticipationInfosById } from '../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/course_participation/actions';
import {
    selectCustomersCourseParticipation,
    selectMayAccessLearning,
} from '../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/course_participation/selectors';

@Injectable()
export class LearningGuard implements CanActivate {
    constructor(private store: Store, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const courseParticipationId = route.params.courseParticipationId;
        this.store.dispatch(
            loadCourseParticipationInfosById({ courseParticipationId })
        );

        return this.store.select(selectCustomersCourseParticipation).pipe(
            filter(
                courseParticipation =>
                    courseParticipation?.id === courseParticipationId
            ),
            switchMap(courseParticipation =>
                this.store
                    .select(
                        selectMayAccessLearning(
                            route.data.alwaysAllowedCourseTypes ?? []
                        )
                    )
                    .pipe(
                        filterNil(),
                        map(({ allowed, reason }) => {
                            const isExpiredRepetitorium =
                                reason === 'expired' &&
                                courseParticipation?.bookedCourse.modules.some(
                                    module =>
                                        module.id === route.params.moduleId &&
                                        module.type ===
                                            LearnModuleType.Repetitorium
                                );

                            return (
                                allowed ||
                                isExpiredRepetitorium ||
                                this.router.createUrlTree([
                                    '/',
                                    courseParticipationId,
                                ])
                            );
                        })
                    )
            )
        );
    }
}
